import { getVoiceApiOrigin } from "./voiceLiveDemoLogic";
import type { TranscriptTurn } from "./voiceLiveDemoLogic";

export type SentimentClassification = "Positive" | "Neutral" | "Negative";

export interface VoiceSentimentResult {
  classification: SentimentClassification;
  shortLabel: string;
  description: string;
}

export async function fetchVoiceSentiment(
  transcript: TranscriptTurn[]
): Promise<VoiceSentimentResult> {
  const apiOrigin = getVoiceApiOrigin();
  const response = await fetch(`${apiOrigin}/api/sentiment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      transcript: transcript.map((turn) => ({
        speaker: turn.speaker,
        text: turn.text,
      })),
    }),
  });

  if (!response.ok) {
    let detail = `Sentiment analysis failed (${response.status})`;
    try {
      const body = await response.json();
      if (typeof body?.detail === "string") detail = body.detail;
      else if (typeof body?.message === "string") detail = body.message;
    } catch {
      const text = await response.text();
      if (text) detail = text;
    }
    throw new Error(detail);
  }

  return response.json();
}
